import {ThunkDispatch} from "@reduxjs/toolkit"
import { useNavigate } from "react-router-dom"
import {useSelector, useDispatch } from "react-redux"
import {currentUserActions} from '../reducers/currentUser'
import { useEffect } from "react";
import CanNotAccess from "./CanNotAccess";

const SuperUserLogin = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate();
  const currentUser = useSelector((state: any) => state.currentUser)
  const { resMessage } = currentUser

  useEffect(() => {
    dispatch(currentUserActions.getCurrentUser({ navigate, view: "control" }))
      .unwrap()
      .then(() => {
        dispatch(currentUserActions.loginSuperUser({ navigate }));
      });
  }, []);


  if(resMessage) return <CanNotAccess />
  return null;
};

export default SuperUserLogin;
